
class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.notification.addEventListener('keyup', (evt) => {
      if (evt.code === 'Escape') this.close();
    });

    this.querySelectorAll('button[type="button"]').forEach((button) => {
      button.addEventListener('click', this.close.bind(this));
    });
  }

  open() {
    this.notification.classList.add('animate', 'active');

    this.notification.addEventListener(
      'transitionend',
      () => {
        this.notification.focus();
        trapFocus(this.notification);
      },
      { once: true }
    );

    document.body.addEventListener('click', this.onBodyClick);

    this.dispatchCartViewEvent();
  }

  async dispatchCartViewEvent() {
    const { CartViewEvent } = window.StandardEvents || {};
    if (!CartViewEvent) return;

    try {
      const response = await fetch(`${routes.cart_url}.json`);
      const cart = await response.json();

      if (!cart?.currency) return;

      this.dispatchEvent(
        new CartViewEvent({
          context: 'dialog',
          cart: CartViewEvent.createCartFromAjaxResponse(cart),
        })
      );
    } catch (e) {
      // El evento es informativo.
    }
  }

  close() {
    this.notification.classList.remove('active');
    document.body.removeEventListener('click', this.onBodyClick);
    removeTrapFocus(this.activeElement);
  }

  clearPartialNotice() {
    this.notification
      .querySelectorAll('[data-partial-stock-notice]')
      .forEach((element) => element.remove());
  }

  renderContents(parsedState) {
    this.clearPartialNotice();
    this.cartItemKey = parsedState.key;

    this.getSectionsToRender().forEach((section) => {
      const target = document.getElementById(section.id);
      const html = parsedState.sections?.[section.id];

      if (!target || !html) return;

      const content = this.getSectionInnerHTML(
        html,
        section.selector
      );

      if (content !== null) {
        target.innerHTML = content;
      }
    });

    if (this.header) this.header.reveal();

    this.open();
  }

  // Muestra el popup cuando Shopify añadió menos
  // unidades de las solicitadas.
  async renderPartialContents(cart, itemKey, requested, added) {
    const sectionIds = this.getSectionsToRender()
      .map((section) => section.id);

    const url = new URL(window.location.href);
    url.searchParams.set('sections', sectionIds.join(','));

    const response = await fetch(url.toString(), {
      cache: 'no-store'
    });

    if (!response.ok) {
      throw new Error('No se pudo actualizar la notificación');
    }

    const sections = await response.json();

    if (sectionIds.some((id) => !sections[id])) {
      throw new Error('Faltan secciones del carrito');
    }

    this.renderContents({
      key: itemKey,
      sections
    });

    const notice = document.createElement('div');

    notice.dataset.partialStockNotice = 'true';
    notice.setAttribute('role', 'status');

    notice.style.cssText = [
      'padding: 12px 14px',
      'margin: 12px 0',
      'border-radius: 6px',
      'background: #fff8e7',
      'border: 1px solid #e7c777',
      'color: #594414',
      'font-size: 13px',
      'line-height: 1.5'
    ].join(';');

    const heading = document.createElement('strong');
    heading.textContent = 'Disponibilidad limitada';
    heading.style.display = 'block';

    const description = document.createElement('span');

    description.textContent =
      `Solicitaste ${requested} ${requested === 1 ? 'unidad' : 'unidades'}, ` +
      `pero solo se ${added === 1 ? 'agregó' : 'agregaron'} ` +
      `${added} ${added === 1 ? 'unidad' : 'unidades'} al carrito.`;

    notice.append(heading, description);

    const productContainer =
      document.getElementById('cart-notification-product');

    if (productContainer) {
      productContainer.insertAdjacentElement('afterend', notice);
    }

    return {
      ...cart,
      key: itemKey,
      sections
    };
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`
      },
      {
        id: 'cart-notification-button'
      },
      {
        id: 'cart-icon-bubble'
      }
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    const documentFragment =
      new DOMParser().parseFromString(html, 'text/html');

    return documentFragment.querySelector(selector)?.innerHTML ?? null;
  }

  handleBodyClick(evt) {
    const target = evt.target;

    if (
      target !== this.notification &&
      !target.closest('cart-notification')
    ) {
      const disclosure =
        target.closest('details-disclosure, header-menu');

      this.activeElement = disclosure
        ? disclosure.querySelector('summary')
        : null;

      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);
